<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<div class="qv-tble-header">
    <span class="heading">Locomotives</span>
    <div class="pdf-icon">
        <span></span>
        <input type="button" value="Download" class="p-button-secondary pull-right" (click)="downloadLocoExcel()">
    </div>
    <strong class="paginnatiom" *ngIf="totalRecords"> Total records {{locoDataTable.filteredValue !== undefined && locoDataTable.filteredValue !== null ? locoDataTable?.filteredValue?.length : totalRecords}}</strong> 
</div>
<div class="query-view-tables clear">

    <div class="clear"></div>
    <p-table #dt [value]="loadData?.data"  [rows]="100" [totalRecords]="totalRecords" scrollable="true" scrollHeight="{{scrollHeightLocoTable}}"
        scrollWidth="100%" [style]="{'margin-top':'10px'}" id="queryViewLocoMotiveResults">
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="terminal" class="qv-serial">#</th>
                <th class="blue-bold" pSortableColumn="locomotiveId" [style]="{'width':'110px'}">{{configData.queryViewLabel.locomotive}}
                    <p-sortIcon field="locomotiveId"></p-sortIcon>
                </th>        
                <th class="y-colum" pSortableColumn="locoIdColor" [style]="{'width':'25px'}">
                    <p-sortIcon field="locoIdColor"></p-sortIcon>
                </th>        
                <th class="blue-bold" pSortableColumn="lmsLocation" [style]="{'width':'110px'}">{{configData.queryViewLabel.currentAssignment}}
                    <p-sortIcon field="lmsLocation"></p-sortIcon>
                </th>
                <th class="blue-bold" pSortableColumn="trainDestination" [style]="{'width':'110px'}">{{configData.queryViewLabel.destination}}
                    <p-sortIcon field="trainDestination"></p-sortIcon>
                </th>        
                <th pSortableColumn="status" [style]="{'width':'80px'}">{{configData.queryViewLabel.status}}
                    <p-sortIcon field="status"></p-sortIcon>
                </th>        
                <th pSortableColumn="classCode" [style]="{'width':'80px'}">{{configData.queryViewLabel.class}}
                    <p-sortIcon field="classCode"></p-sortIcon>
                </th>        
                <th pSortableColumn="axle" [style]="{'width':'60px'}">{{configData.queryViewLabel.axles}}
                    <p-sortIcon field="axle"></p-sortIcon>
                </th>        
                <th pSortableColumn="ptcEquipped" [style]="{'width':'60px'}">{{configData.queryViewLabel.ptc}}
                    <p-sortIcon field="ptcEquipped"></p-sortIcon>
                </th>        
                <th class="qvt-last-fueled" pSortableColumn="lastFuelDate" [style]="{'width':'145px'}">{{configData.queryViewLabel.lastFueled}}
                    <p-sortIcon field="lastFuelDate"></p-sortIcon>
                </th>
                <th pSortableColumn="milesRemaining" [style]="{'width':'70px'}">{{configData.queryViewLabel.miles}}
                    <p-sortIcon field="milesRemaining"></p-sortIcon>
                </th>
        
                <th pSortableColumn="fuelLevel" [style]="{'width':'60px'}">{{configData.queryViewLabel.fuel}}
                    <p-sortIcon field="fuelLevel"></p-sortIcon>
                </th>
        
                <th pSortableColumn="nextQDate" [style]="{'width':'100px'}">{{configData.queryViewLabel.qDue}}
                    <p-sortIcon field="nextQDate"></p-sortIcon>
                </th>
        
                <th pSortableColumn="serviceDueDate" [style]="{'width':'110px'}">{{configData.queryViewLabel.serviceDue}}
                    <p-sortIcon field="serviceDueDate"></p-sortIcon>
                </th>
        
                <th pSortableColumn="deadDate" [style]="{'width':'100px'}">{{configData.queryViewLabel.deadDate}}
                    <p-sortIcon field="deadDate"></p-sortIcon>
                </th>
        
                <th pSortableColumn="mechInspecDueDate" [style]="{'width':'100px'}">{{configData.queryViewLabel.nextDays}}
                    <p-sortIcon field="mechInspecDueDate"></p-sortIcon>
                </th>
        
                <th pSortableColumn="airFlowDueDate" [style]="{'width':'100px'}">{{configData.queryViewLabel.nextAirFlow}}
                    <p-sortIcon field="airFlowDueDate"></p-sortIcon>
                </th>
        
                <th pSortableColumn="plannedAssign" [style]="{'width':'160px'}">{{configData.queryViewLabel.nextPlannedAssignment}}
                    <p-sortIcon field="plannedAssign"></p-sortIcon>
                </th>
        
                <th pSortableColumn="lastReportingDateTime" [style]="{'width':'130px'}">{{configData.queryViewLabel.lastReporting}}
                    <p-sortIcon field="lastReportingDateTime"></p-sortIcon>
                </th>
        
                <th pSortableColumn="lastReportingType" [style]="{'width':'120px'}">{{configData.queryViewLabel.lastReporting}} {{configData.queryViewLabel.type}}
                    <p-sortIcon field="lastReportingType"></p-sortIcon>
                </th>
        
                <th pSortableColumn="lastReportingCityState" [style]="{'width':'190px'}">{{configData.queryViewLabel.lastReporting}} {{configData.queryViewLabel.city}} {{configData.queryViewLabel.state}}
                    <p-sortIcon field="lastReportingCityState"></p-sortIcon>
                </th>

                <th pSortableColumn="oprtngRegionName" [style]="{'width':'150px'}">{{configData.queryViewLabel.oprRegion}}
                    <p-sortIcon field="oprtngRegionName"></p-sortIcon>
                </th>
                
                <th pSortableColumn="oprtngZoneName" [style]="{'width':'170px'}">{{configData.queryViewLabel.oprZone}}
                    <p-sortIcon field="oprtngZoneName"></p-sortIcon>
                </th>
        
                <th pSortableColumn="allocStation" [style]="{'width':'100px'}">{{configData.queryViewLabel.allocationStation}}
                    <p-sortIcon field="allocStation"></p-sortIcon>
                </th>
        
                <th pSortableColumn="allocType" [style]="{'width':'100px'}">{{configData.queryViewLabel.allocationType}}
                    <p-sortIcon field="allocType"></p-sortIcon>
                </th>
        
                <th pSortableColumn="permAlloc" [style]="{'width':'105px'}">{{configData.queryViewLabel.permAllocation}}
                    <p-sortIcon field="permAlloc"></p-sortIcon>
                </th>
        
                <th pSortableColumn="allocDivision" [style]="{'width':'90px'}">{{configData.queryViewLabel.division}}
                    <p-sortIcon field="allocDivision"></p-sortIcon>
                </th>
        
                <th pSortableColumn="permTag" [style]="{'width':'95px'}">{{configData.queryViewLabel.permtag}}
                    <p-sortIcon field="permTag"></p-sortIcon>
                </th>
        
                <th pSortableColumn="locoTag" [style]="{'width':'90px'}">{{configData.queryViewLabel.locotag}}
                    <p-sortIcon field="locoTag"></p-sortIcon>
                </th>
        
                <th pSortableColumn="typeOfService" [style]="{'width':'100px'}">{{configData.queryViewLabel.typeOfService}}
                    <p-sortIcon field="typeOfService"></p-sortIcon>
                </th>
        
                <th pSortableColumn="nextQType" [style]="{'width':'70px'}">{{configData.queryViewLabel.nextQ}}
                    <p-sortIcon field="nextQType"></p-sortIcon>
                </th>
        
                <th pSortableColumn="remarks" [style]="{'width':'230px'}">{{configData.queryViewLabel.remarks}}
                    <p-sortIcon field="remarks"></p-sortIcon>
                </th>
        
                <th pSortableColumn="oosFlag" [style]="{'width':'80px'}">{{configData.queryViewLabel.oos}}
                    <p-sortIcon field="oosFlag"></p-sortIcon>
                </th>
        
                <th pSortableColumn="partialPowerFlag" [style]="{'width':'80px'}">{{configData.queryViewLabel.partialPower}}
                    <p-sortIcon field="partialPowerFlag"></p-sortIcon>
                </th>
        
                <th pSortableColumn="trailOnlyFlag" [style]="{'width':'100px'}">{{configData.queryViewLabel.trailOnly}}
                    <p-sortIcon field="trailOnlyFlag"></p-sortIcon>
                </th>
        
                <th pSortableColumn="workToShopFlag" [style]="{'width':'70px'}">{{configData.queryViewLabel.workToShop}}
                    <p-sortIcon field="workToShopFlag"></p-sortIcon>
                </th>
        
                <th pSortableColumn="notes" [style]="{'width':'760px'}">{{configData.queryViewLabel.Notes}} 1
                    <p-sortIcon field="notes"></p-sortIcon>
                </th>
        
                <th pSortableColumn="notes" [style]="{'width':'760px'}">{{configData.queryViewLabel.Notes}} 2
                    <p-sortIcon field="notes"></p-sortIcon>
                </th>
                <th pSortableColumn="notes" [style]="{'width':'760px'}">{{configData.queryViewLabel.Notes}} 3
                    <p-sortIcon field="notes"></p-sortIcon>
                </th>
            </tr>
            <tr>
                <th field="terminal"></th>
                <th class="blue-bold" [style]="{'width':'110px'}" >
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'locomotiveId', 'contains')" class="p-inputtext">
                </th>
        
                <th class="y-colum" [style]="{'width':'25px'}" >
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'locoIdColor', 'contains')" class="p-inputtext" style="padding: 0;">
                </th>
        
                <th class="blue-bold" [style]="{'width':'110px'}" >
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'lmsLocation', 'contains')" class="p-inputtext">
                </th>
        
                <th class="blue-bold" [style]="{'width':'110px'}" >
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'trainDestination', 'contains')" class="p-inputtext">
                </th>
        
                <th [style]="{'width':'80px'}" >
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'status', 'contains')" class="p-inputtext">
                </th>
        
                <th [style]="{'width':'80px'}" >
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'classCode', 'contains')" class="p-inputtext">
                </th>
        
                <th [style]="{'width':'60px'}" >
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'axle', 'contains')" class="p-inputtext">
                </th>
        
                <th [style]="{'width':'60px'}" >
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'ptcEquipped', 'contains')" class="p-inputtext">
                </th>
        
                <th class="qvt-last-fueled" [style]="{'width':'145px'}" >
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'lastFuelDate', 'contains')" class="p-inputtext">
                </th>
                <th [style]="{'width':'70px'}" >
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'milesRemaining', 'contains')" class="p-inputtext">
                </th>
        
                <th [style]="{'width':'60px'}" >
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'fuelLevel', 'contains')" class="p-inputtext">
                </th>
        
                <th [style]="{'width':'100px'}">
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'nextQDate', 'contains')" class="p-inputtext">
                </th>
        
                <th [style]="{'width':'110px'}">
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'serviceDueDate', 'contains')" class="p-inputtext">
                </th>
        
                <th [style]="{'width':'100px'}">
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'deadDate', 'contains')" class="p-inputtext">
                </th>
        
                <th [style]="{'width':'100px'}">
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'mechInspecDueDate', 'contains')" class="p-inputtext">
                </th>
        
                <th [style]="{'width':'100px'}">
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'airFlowDueDate', 'contains')" class="p-inputtext">
                </th>
        
                <th [style]="{'width':'160px'}">
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'plannedAssign', 'contains')" class="p-inputtext">
                </th>
        
                <th [style]="{'width':'130px'}" >
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'lastReportingDateTime', 'contains')" class="p-inputtext">
                </th>
        
                <th [style]="{'width':'120px'}" >
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'lastReportingType', 'contains')" class="p-inputtext">
                </th>
        
                <th [style]="{'width':'190px'}" >
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'lastReportingCityState', 'contains')" class="p-inputtext">
                </th>
                <th [style]="{'width':'150px'}" >
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'oprtngRegionName', 'contains')" class="p-inputtext">
                </th>
                
                <th [style]="{'width':'170px'}" >
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'oprtngZoneName', 'contains')" class="p-inputtext">
                </th>
        
                <th [style]="{'width':'100px'}" >
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'allocStation', 'contains')" class="p-inputtext">
                </th>
        
                <th [style]="{'width':'100px'}">
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'allocType', 'contains')" class="p-inputtext">
                </th>
        
                <th [style]="{'width':'105px'}">
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'permAlloc', 'contains')" class="p-inputtext">
                </th>
        
                <th [style]="{'width':'90px'}">
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'allocDivision', 'contains')" class="p-inputtext">
                </th>
        
                <th [style]="{'width':'95px'}" >
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'permTag', 'contains')" class="p-inputtext">
                </th>
        
                <th [style]="{'width':'90px'}" >
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'locoTag', 'contains')" class="p-inputtext">
                </th>
        
                <th [style]="{'width':'100px'}">
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'typeOfService', 'contains')" class="p-inputtext">
                </th>
        
                <th [style]="{'width':'70px'}">
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'nextQType', 'contains')" class="p-inputtext">
                </th>
        
                <th [style]="{'width':'230px'}">
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'remarks', 'contains')" class="p-inputtext">
                </th>
        
                <th [style]="{'width':'80px'}">
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'oosFlag', 'contains')" class="p-inputtext">
                </th>
        
                <th [style]="{'width':'80px'}">
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'partialPowerFlag', 'contains')" class="p-inputtext">
                </th>
        
                <th [style]="{'width':'100px'}">
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'trailOnlyFlag', 'contains')" class="p-inputtext">
                </th>
        
                <th [style]="{'width':'70px'}">
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'workToShopFlag', 'contains')" class="p-inputtext">
                </th>
        
                <th [style]="{'width':'760px'}">
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'notes', 'contains')" class="p-inputtext">
                </th>
        
                <th [style]="{'width':'760px'}" >
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'notes', 'contains')" class="p-inputtext">
                </th>
                <th [style]="{'width':'760px'}"> 
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'notes', 'contains')" class="p-inputtext">
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data let-rowIndex="rowIndex">
            <tr>
                <td class="qv-serial">
                    <span>{{ rowIndex + 1 }}</span>
                </td>
                <td class="blue-bold" [style]="{'width':'110px'}">
                        <span *ngIf="data['locomotiveId']" id="locomotive{{data['locomotiveId']}}" (contextmenu)='$event.preventDefault();setOverlayLinks("loco" ,data); locomotiveOverlayPosition($event, overlayMenuLinks, data, "loco")'
                            (click)="goToLoco(data['locomotiveId'])">
                   {{data['locomotiveId']}}</span>
                        <span *ngIf="!data['locomotiveId']">-</span>
                </td>
        
                <td class="y-colum" [style]="{'width':'25px'}">
                        <span [ngClass]="{'yellow':data['locoIdColor']==='Y','red': data['locoIdColor']==='R'}">
                  {{data['locoIdColor']}}</span>
                </td>
        
                <td class="blue-bold" [style]="{'width':'110px'}">
                        <span *ngIf="data['lmsLocation'] && isTrain(data['lmsLocation'])" id="train{{data['lmsLocation']}}" (click)="goToTrainTerminal(data['lmsLocation'])"
                            (contextmenu)='$event.preventDefault();setOverlayLinks("train"); locomotiveOverlayPosition($event, overlayMenuLinks, data,
                "train")'>{{data['lmsLocation']}}</span>
        
                        <span *ngIf="data['lmsLocation'] && !isTrain(data['lmsLocation'])" (click)="goToTrainTerminal(data['lmsLocation'])">{{data['lmsLocation']}}</span>
                        <span *ngIf="!data['lmsLocation']">-</span>
                </td>
        
                <td class="blue-bold" [style]="{'width':'110px'}" >
                        <span *ngIf="data['trainDestination']" (click)="goToTrainTerminal(data['trainDestination'])">{{data['trainDestination']}}</span>
                        <span *ngIf="!data['trainDestination']">-</span>
                </td>
        
                <td [style]="{'width':'80px'}">
                        <span>{{ data['status']  ? data['status'] : '-'}}</span>
                </td>
        
                <td [style]="{'width':'80px'}">
                        <span>{{ data['classCode']  ? data['classCode'] : '-'}}</span>
                </td>
        
                <td [style]="{'width':'60px'}" >
                        <span>{{ data['axle']  ? data['axle'] : '-'}}</span>
                </td>
        
                <td [style]="{'width':'60px'}" >
                        <span>{{ data['ptcEquipped']  ? data['ptcEquipped'] : '-'}}</span>
                </td>
        
                <td class="qvt-last-fueled" [style]="{'width':'145px'}">
                        <span>{{ data['lastFuelDate']  ? data['lastFuelDate'] : '-'}}</span>
                </td>
                <td [style]="{'width':'70px'}">
                        <span>{{ data['milesRemaining']}}</span>
                </td>
        
                <td [style]="{'width':'60px'}">
                        <span>{{data['fuelLevel']}}</span>
                </td>
        
                <td [style]="{'width':'100px'}">
                        <span>{{ data['nextQDate']  ? data['nextQDate'] : '-'}}</span>
                </td>
        
                <td [style]="{'width':'110px'}">
                        <span>{{ data['serviceDueDate']  ? data['serviceDueDate'] : '-'}}</span>
                </td>
        
                <td [style]="{'width':'100px'}">
                    <span>{{ data['deadDate']  ? data['deadDate'] : '-'}}</span>
                </td>
        
                <td [style]="{'width':'100px'}" >
                    <span>{{ data['mechInspecDueDate']  ? data['mechInspecDueDate'] : '-'}}</span>
                </td>
        
                <td [style]="{'width':'100px'}" >
                    <span>{{ data['airFlowDueDate']  ? data['airFlowDueDate'] : '-'}}</span>
                </td>
        
                <td [style]="{'width':'160px'}" >
                    <span>{{ data['plannedAssign']  ? data['plannedAssign'] : '-'}}</span>
                </td>
        
                <td [style]="{'width':'130px'}" >
                    <span>{{ data['lastReportingDateTime']  ? data['lastReportingDateTime'] : '-'}}</span>
                </td>
        
                <td [style]="{'width':'120px'}" >
                    <span>{{ data['lastReportingType']  ? data['lastReportingType'] : '-'}}</span>
                </td>
        
                <td [style]="{'width':'190px'}" >
                    <span>{{ data['lastReportingCityState']  ? data['lastReportingCityState'] : '-'}}</span>
                </td>
                
                <td [style]="{'width':'150px'}" >
                    <span>{{ data['oprtngRegionName']  ? data['oprtngRegionName'] : '-'}}</span>
                </td>
                
                <td [style]="{'width':'170px'}" >
                    <span>{{ data['oprtngZoneName']  ? data['oprtngZoneName'] : '-'}}</span>
                </td>
        
                <td [style]="{'width':'100px'}" >
                    <span>{{ data['allocStation']  ? data['allocStation'] : '-'}}</span>
                </td>
        
                <td [style]="{'width':'100px'}" >
                    <span>{{ data['allocType']  ? data['allocType'] : '-'}}</span>
                </td>
        
                <td [style]="{'width':'105px'}" >
                    <span>{{ data['permAlloc']  ? data['permAlloc'] : '-'}}</span>
                </td>
        
                <td [style]="{'width':'90px'}" >
                    <span>{{ data['allocDivision']  ? data['allocDivision'] : '-'}}</span>
                </td>
        
                <td [style]="{'width':'95px'}" >
                    <span>{{ data['permTag']  ? data['permTag'] : '-'}}</span>
                </td>
        
                <td [style]="{'width':'90px'}" >
                    <span>{{ data['locoTag']  ? data['locoTag'] : '-'}}</span>
                </td>
        
                <td [style]="{'width':'100px'}" >
                    <span>{{ data['typeOfService']  ? data['typeOfService'] : '-'}}</span>
                </td>
        
                <td [style]="{'width':'70px'}" >
                    <span>{{ data['nextQType']  ? data['nextQType'] : '-'}}</span>
                </td>
        
                <td [style]="{'width':'230px'}" >
                    <span>{{ data['remarks']  ? data['remarks'] : '-'}}</span>
                </td>
        
                <td [style]="{'width':'80px'}" >
                    <span>{{ data['oosFlag']  ? data['oosFlag'] : '-'}}</span>
                </td>
        
                <td [style]="{'width':'80px'}" >
                    <span>{{ data['partialPowerFlag']  ? data['partialPowerFlag'] : '-'}}</span>
                </td>
        
                <td [style]="{'width':'100px'}" >
                    <span>{{ data['trailOnlyFlag']  ? data['trailOnlyFlag'] : '-'}}</span>
                </td>
        
                <td [style]="{'width':'70px'}" >
                    <span>{{ data['workToShopFlag']  ? data['workToShopFlag'] : '-'}}</span>
                </td>
        
                <td [style]="{'width':'760px'}" >
                    <span>{{ data['notes'] && data['notes'][0] ? data['notes'][0] : '-'}}</span>
                </td>
        
                <td [style]="{'width':'760px'}" >
                    <span>{{data['notes'] && data['notes'][1] ? data['notes'][1] : '-'}}</span>
                </td>
                <td [style]="{'width':'760px'}" >
                    <span>{{data['notes'] && data['notes'][2] ? data['notes'][2] : '-'}}</span>
                </td>
            </tr>
        </ng-template>
    </p-table>

    <div class="noRecordFound" *ngIf="loadData?.data?.length === 0 ">No records found.</div>
</div>

<p-overlayPanel #overlayMenuLinks [dismissable]="true" id='overlayLinksInfo' [ngClass]="'menu-dropdown'">
    <ul>
        <li *ngFor="let link of overlayLinks">
            <a href="javascript:void(0)" (click)='routeToPage(link.label, contextType, contextSearchText); hideOverlayPanel($event, overlayMenuLinks);'>{{link.label}}</a>
        </li>
    </ul>
</p-overlayPanel>